import React from "react";
import { Col, Row, Button } from "antd";

import { withAppContext } from "contexts/AppContext/AppContext";

import Header from "components/Header/Header";
import SubMenuItemSectionsBar from "components/SubMenuItemSectionsBar/SubMenuItemSectionsBar";
import SubMenuNavBar from "components/SubMenuNavBar/SubMenuNavBar";

import {
  ContentContainer,
  RootContainer,
  SubMenuBar,
  ScrollWrapperContainer,
  SubMenuContainer,
} from "./SubMenuLayout.styles";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { getUserAuthObj } from "utils/auth";
import Language from "components/Language/Language";

const SubMenuLayout = ({ children, getLoggedInUser }) => {
  // const user = getLoggedInUser();
  // const firstName = user && user.name && user.name.firstName;
  // const lastName = user && user.name && user.name.lastName;

  const jwt = getUserAuthObj();

  console.log("jwt", jwt);

  return (
    <RootContainer>
      <SubMenuBar span={2} xl={1}>
        <SubMenuNavBar />
      </SubMenuBar>
      <SubMenuContainer span={6} xl={3}>
        <SubMenuItemSectionsBar />
      </SubMenuContainer>
      <ContentContainer span={16} xl={20}>
        <ScrollWrapperContainer>
          <Row justify="end" gutter={16}>
            <Col>
              <Button
                icon={<QuestionCircleOutlined style={{ color: "#d7a301" }} />}
                style={{
                  color: "#d7a301",
                  borderColor: "#d7a301",
                  marginTop: 6,
                }}
                href="https://faq.finportpulse.com/"
                target="_blank"
              >
                FAQ
              </Button>
            </Col>
            <Col
              style={{
                marginTop: 6,
              }}
            >
              <Language />
            </Col>
            <Col>
              <Header
                firstName={jwt.name.firstName}
                lastName={jwt.name.lastName}
                companyLogo={
                  jwt && jwt.company && jwt.company.logo && jwt.company.logo.url
                }
              />
            </Col>
          </Row>
          <div>{children}</div>
        </ScrollWrapperContainer>
      </ContentContainer>
    </RootContainer>
  );
};

export default withAppContext(SubMenuLayout);
